import Swal from "sweetalert2";

export default function InfoAlert(msg) {
  Swal.fire({
    title: `<p style="font-size:22px;">${msg}</p>`,
    icon: "info",
    confirmButtonText: "Close",
    customClass: {
      confirmButton: "infoButton", // managed in App.css
      title: "MuiTypography-h6",
    },
    buttonsStyling: false,
  });
}
